module.exports = __webpack_public_path__ + "img/Pic_Title_XMJS.002cdb44.png";